export default "__VITE_ASSET__Fh0yo96I__"